const WELCOME_MESSAGE_DIALOG = 'WELCOME_MESSAGE_DIALOG';

export default WELCOME_MESSAGE_DIALOG;
